/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Metadata from '../model/Metadata';
import MetadataSet from '../model/MetadataSet';

/**
* Metadata service.
* @module api/MetadataApi
* @version 1.0.0
*/
export default class MetadataApi {

    /**
    * Constructs a new MetadataApi. 
    * @alias module:api/MetadataApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the addMetadata operation.
     * @callback module:api/MetadataApi~addMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Metadata} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/Metadata} [metadata] 
     * @param {module:api/MetadataApi~addMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Metadata}
     */
    addMetadata(opts, callback) {
      opts = opts || {};
      let postBody = opts['metadata'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Metadata;
      return this.apiClient.callApi(
        '/metadata', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the addMetadataSet operation.
     * @callback module:api/MetadataApi~addMetadataSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MetadataSet} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MetadataSet} [metadataSet] 
     * @param {module:api/MetadataApi~addMetadataSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MetadataSet}
     */
    addMetadataSet(opts, callback) {
      opts = opts || {};
      let postBody = opts['metadataSet'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = MetadataSet;
      return this.apiClient.callApi(
        '/metadataSet', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAllMetadataSets operation.
     * @callback module:api/MetadataApi~getAllMetadataSetsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MetadataSet>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/MetadataApi~getAllMetadataSetsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MetadataSet>}
     */
    getAllMetadataSets(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [MetadataSet];
      return this.apiClient.callApi(
        '/metadataSet/all', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getMetadata operation.
     * @callback module:api/MetadataApi~getMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Metadata} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} id 
     * @param {module:api/MetadataApi~getMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Metadata}
     */
    getMetadata(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getMetadata");
      }

      let pathParams = {
      };
      let queryParams = {
        'id': id
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Metadata;
      return this.apiClient.callApi(
        '/metadata', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getMetadataSets operation.
     * @callback module:api/MetadataApi~getMetadataSetsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MetadataSet} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {String} [id] 
     * @param {module:api/MetadataApi~getMetadataSetsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MetadataSet}
     */
    getMetadataSets(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'id': opts['id']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = MetadataSet;
      return this.apiClient.callApi(
        '/metadataSet', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateMetadata operation.
     * @callback module:api/MetadataApi~updateMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Metadata} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/Metadata} [metadata] 
     * @param {module:api/MetadataApi~updateMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Metadata}
     */
    updateMetadata(opts, callback) {
      opts = opts || {};
      let postBody = opts['metadata'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Metadata;
      return this.apiClient.callApi(
        '/metadata', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateMetadataSet operation.
     * @callback module:api/MetadataApi~updateMetadataSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MetadataSet} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MetadataSet} [metadataSet] 
     * @param {module:api/MetadataApi~updateMetadataSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MetadataSet}
     */
    updateMetadataSet(opts, callback) {
      opts = opts || {};
      let postBody = opts['metadataSet'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = MetadataSet;
      return this.apiClient.callApi(
        '/metadataSet', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
